export enum ContactApiRoutes {
  ContactCurrentSession = '/contacts/current-session',
  CallDetails = '/contacts/call-details',
  CallScript = '/contacts/call-script',
  RecentAIVendorInteraction = '/contacts/:id/recent-aivendor-interaction',
  RecentAIVendorLeadInteraction = '/contacts/:id/recent-aivendor-lead-interaction',
  CallPreview = '/contacts/leads/:id/preview',
  PostSaleSurvey = '/contacts/:id/post-sale-survey',
  ContactSessionEvents = '/contacts/sessions/:id/events',
  ContactMaskCall = '/contacts/:id/sessions/:id/mask',
  ContactUnmaskCall = '/contacts/:id/sessions/:id/unmask',
  ClearInteractions = '/contacts/:id/interactions/clear',
}
